export default {
  title: '会員管理',
  memberList: '会員一覧',
  memberLevel: '会員レベル',
};
